import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Lock, Mail, Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GuestLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    email: "",
    password: ""
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(`${API}/guest/login`, credentials);
      
      // Store token and booking ID
      localStorage.setItem("guest_token", res.data.token);
      localStorage.setItem("guest_email", res.data.guest_email);
      localStorage.setItem("booking_id", res.data.booking_id);
      
      toast.success("Welcome! Redirecting to your portal...");
      navigate("/guest-portal");
    } catch (error) {
      console.error("Login error:", error);
      toast.error(error.response?.data?.detail || "Invalid credentials. Please check your email and password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#E6F2F1] to-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo/Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-serif text-[#134E4A] mb-2">Chestnut Hill Inn</h1>
          <p className="text-[#78716C]">Guest Portal</p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-2xl font-serif text-[#134E4A] mb-6 text-center">
            Access Your Reservation
          </h2>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-[#134E4A]">Email Address</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-3 h-5 w-5 text-[#78716C]" />
                <Input
                  id="email"
                  type="email"
                  placeholder="your.email@example.com"
                  value={credentials.email}
                  onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                  className="pl-10"
                  required
                />
              </div>
            </div>

            <div>
              <Label htmlFor="password" className="text-[#134E4A]">Password</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-3 h-5 w-5 text-[#78716C]" />
                <Input
                  id="password"
                  type="password"
                  placeholder="Chestnuthill2026"
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  className="pl-10"
                  required
                />
              </div>
              <p className="text-xs text-[#78716C] mt-1">
                Use password: Chestnuthill2026
              </p>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#134E4A] hover:bg-[#0F3A38] text-white"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Signing in...
                </>
              ) : (
                "Access Portal"
              )}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Button
              variant="link"
              onClick={() => navigate("/")}
              className="text-[#134E4A]"
            >
              ← Back to Home
            </Button>
          </div>
        </div>

        {/* Help Text */}
        <div className="mt-6 text-center text-sm text-[#78716C]">
          <p>Having trouble? Contact us at</p>
          <p className="text-[#134E4A] font-medium">booking@chestnuthillinn.com</p>
        </div>
      </div>
    </div>
  );
}
